import { useState } from "react";
import moment from "moment";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
import ModalDownloadDismantleKpi from "../../components/schedule/ModalDownloadDismantleKpi";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import { useDismantleScheduleKpiHooks } from "../../utils/SchedulesUtil";

function formatDate(timestamp) {
  return timestamp == null ? "-" : moment.unix(timestamp).format("DD MMM YYYY - HH:mm");
}

export default function DismantleKpiPage() {
  const { hasAccess } = useControlPermission();
  const { projects } = useGroupListHooks();
  const [formFilter, setFormFilter] = useState({
    status: "",
    project_id: "",
    date_from: "",
    date_until: "",
  });
  const [filter, setFilter] = useState({
    status: "",
    project_id: "",
    date_from: "",
    date_until: "",
    page: 1,
    page_size: 10,
  });
  const [showModalDownload, setShowModalDownload] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const { data, meta, loading, errorMsg } = useDismantleScheduleKpiHooks({ filter });
  const totalPages = Math.ceil(meta.count / meta.page_size);

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const applyFilter = (event) => {
    event.preventDefault();
    setFilter({ ...filter, ...formFilter, page: 1 });
  };

  const resetFilter = () => {
    setFormFilter({ status: "", project_id: "", date_from: "", date_until: "" });
    setFilter({ status: "", project_id: "", date_from: "", date_until: "", page: 1, page_size: 10 });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: Math.max(1, Math.min(page, totalPages || 1)) });
  };

  const onDownloadSuccess = (message) => {
    setAlert({ show: true, message, type: "success" });
  };

  return (
    <MainLayout resource_key="schedule">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">KPI Dismantle</h1>
          </div>
          <div className="col-auto">
            {hasAccess("view-schedule-kpi") && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowModalDownload(true)}
              >
                <i className="fas fa-download" aria-hidden="true"></i> Unduh Data KPI Dismantle
              </button>
            )}
          </div>
        </div>

        <Box title={`Daftar KPI Dismantle (Total Data: ${meta.count})`} loading={loading}>
          <form onSubmit={applyFilter} className="mb-4">
            <div className="row align-items-end">
              <div className="col-12 col-md-4 col-lg-2">
                <div className="form-group">
                  <label htmlFor="dismantle-kpi-status">Status</label>
                  <select
                    id="dismantle-kpi-status"
                    className="form-control"
                    value={formFilter.status}
                    onChange={(event) => changeFilter("status", event.target.value)}
                  >
                    <option value="">SEMUA</option>
                    <option value="WAITING-NOC">WAITING NOC</option>
                    <option value="NOC-DONE">NOC DONE</option>
                    <option value="DONE">DONE</option>
                    <option value="CANCELED">CANCELED</option>
                  </select>
                </div>
              </div>
              <div className="col-12 col-md-4 col-lg-2">
                <div className="form-group">
                  <label htmlFor="dismantle-kpi-project">Project/Site</label>
                  <select
                    id="dismantle-kpi-project"
                    className="form-control"
                    value={formFilter.project_id}
                    onChange={(event) => changeFilter("project_id", event.target.value)}
                  >
                    <option value="">SEMUA</option>
                    {projects.map((project) => (
                      <option value={project.id} key={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-12 col-md-4 col-lg-2">
                <div className="form-group">
                  <label htmlFor="dismantle-kpi-date-from">Tanggal Dari</label>
                  <input
                    type="date"
                    id="dismantle-kpi-date-from"
                    className="form-control"
                    value={formFilter.date_from}
                    onChange={(event) => changeFilter("date_from", event.target.value)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-4 col-lg-2">
                <div className="form-group">
                  <label htmlFor="dismantle-kpi-date-until">Tanggal Sampai</label>
                  <input
                    type="date"
                    id="dismantle-kpi-date-until"
                    className="form-control"
                    value={formFilter.date_until}
                    onChange={(event) => changeFilter("date_until", event.target.value)}
                  />
                </div>
              </div>
              <div className="col-auto">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary">
                    Filter
                  </button>
                  <button type="button" className="btn btn-default" onClick={resetFilter}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </form>

          <AlertBox {...alert} setAlert={setAlert} />
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

          <div className="table-responsive">
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">No. Registrasi</th>
                  <th scope="col">Nama Pelanggan</th>
                  <th scope="col">Project</th>
                  <th scope="col">No. Penugasan</th>
                  <th scope="col">Status</th>
                  <th scope="col">Tanggal Berakhir</th>
                  <th scope="col">Waktu Penugasan</th>
                  <th scope="col">Dijadwalkan Oleh</th>
                  <th scope="col">Waktu BAST</th>
                  <th scope="col">BAST Oleh</th>
                  <th scope="col">Durasi</th>
                </tr>
              </thead>
              <tbody>
                {!loading && !errorMsg && data.length === 0 && (
                  <tr>
                    <td colSpan={11} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.registration_number}</td>
                    <td className="text-nowrap">{item.name}</td>
                    <td>{item.project}</td>
                    <td className="text-nowrap">{item.schedule_number}</td>
                    <td>{item.status}</td>
                    <td className="text-nowrap">{formatDate(item.plan_end_at)}</td>
                    <td className="text-nowrap">{formatDate(item.assigned_at)}</td>
                    <td className="text-nowrap">{item.assigned_by || "-"}</td>
                    <td className="text-nowrap">{formatDate(item.bast_at)}</td>
                    <td className="text-nowrap">{item.bast_by || "-"}</td>
                    <td className="text-nowrap">{item.total_time || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {!loading && meta.count > meta.page_size && (
            <Pagination
              totalpage={totalPages}
              selectedpage={meta.page}
              clickpage={gotoPage}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>
      <ModalDownloadDismantleKpi
        show={showModalDownload}
        onClose={() => setShowModalDownload(false)}
        onSuccess={onDownloadSuccess}
      />
    </MainLayout>
  );
}
